import { useState, useEffect, useRef, useCallback, cloneElement } from 'react';
import './Select.css';
interface iProps {
	label: string;
	labelPosition: 'top' | 'inline';
	selectedItems?: string[];
	buttonClass?: string;
	children: any;
	isSmallScreen?: boolean;
	open?: Function;
	disabled?: boolean | undefined;
	disabledText?: string;
	onClear?: Function;
	multiSelect?: boolean;
};

export default function Select(props: iProps) {

	const [open, setOpen] = useState(false);
	const selectRef = useRef<HTMLDivElement>(null);
	const dropdownButton = useRef<HTMLButtonElement>(null);
	const dropdownContent = useRef<HTMLDivElement>(null);
	const windowClickListener = useCallback((evt: any) => {
		if (evt.target === dropdownButton.current) {
			return;
		}

		if (dropdownContent.current) {
			if (!dropdownContent.current.contains(evt.target)) {
				setOpen(false);
				window.removeEventListener('click', windowClickListener);
			}
		}
	}, [])

	// cleans up event listener
	useEffect(() => {
		return () => {
			window.removeEventListener('click', windowClickListener);
		}
	}, [windowClickListener]);


	const toggleDropdown = (evt: any) => {
		if (!open) {
			setOpen(true);
			window.addEventListener('click', windowClickListener);
		} else {
			closeDropdown(evt);
		}
	}

	const closeDropdown = (evt: any) => {
		setOpen(false);
		window.removeEventListener('click', windowClickListener);
	}

	const onClear = () => {
		if (props.onClear) {
			props.onClear();
		}
	}
	const buttonClass = props.buttonClass ?? '';

	return (
		<div ref={selectRef} className="select">

			{props.labelPosition === 'top' && <label htmlFor={props.label.toLowerCase()}>{props.label}</label>}
			<button name={props.label.toLowerCase()} disabled={props.disabled} ref={dropdownButton} className={`${buttonClass} select-button ${props.disabled ? 'disabled' : ''}`}
				onClick={toggleDropdown}
			>{props.labelPosition === 'inline'
				? props.label
				: props.disabled && props.disabledText
					? props.disabledText
					: props.selectedItems && props.selectedItems?.length > 0
						? props.selectedItems.join(', ')
						: 'All'}
			</button>
			{props.selectedItems
				&& props.selectedItems.length > 0
				&& props.onClear
				&& <button id="clear-btn" onClick={onClear}>x</button>}

			{open &&
				<div ref={dropdownContent} className="select-content">
					<div className="select-child-content">
						{props.multiSelect
							? props.children
							: props.children.map((child: any, index: number) => (
								cloneElement(child, {
									onClick: (evt: any) => {
										child.props.onClick();
										setOpen(false);
									}
								})
							))}
					</div>
					{props.multiSelect &&
						<div className='done'>
							<button className="done-btn " onClick={toggleDropdown}>Close</button>
						</div>
					}
				</div>
			}
		</div>
	)
}
